import { createSvgIcon } from '@mui/material';

const Done = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
    <path
      d='M6.60039 11.9251L3.97539 9.3001C3.68544 9.01015 3.21534 9.01015 2.92539 9.3001C2.63544 9.59005 2.63544 10.0601 2.92539 10.3501L6.60039 14.0251L15.0754 5.5501C15.3653 5.26015 15.3653 4.79005 15.0754 4.5001C14.7854 4.21015 14.3153 4.21015 14.0254 4.5001L6.60039 11.9251Z'
      fill='currentColor'
    />
  </svg>,
  'Done',
);

export default Done;
